import config from 'modules/common/config';

const EMBED_ELEMENT = 'impact-embed';

/**
 * Impact's tracking tag normally pulls this loader in, but `impactcdn.com` sits on common
 * privacy blocklists while the loader host does not. Loading the widget script directly keeps
 * the rewards widget working when only the tracking tag is blocked.
 */
export const ensureImpactAdvocateLoader = () => {
    const { advocateLoaderUrl, tenantAlias } = config.impact;

    if (!advocateLoaderUrl || !tenantAlias) {
        return;
    }

    window.squatchTenant = window.squatchTenant || tenantAlias;

    if (window.customElements.get(EMBED_ELEMENT)) {
        return;
    }

    if (document.querySelector(`script[src="${advocateLoaderUrl}"]`)) {
        return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = advocateLoaderUrl;
    document.head.appendChild(script);
};

export const waitForImpactEmbed = (timeoutMs: number): Promise<boolean> =>
    new Promise((resolve) => {
        const timeout = setTimeout(() => resolve(false), timeoutMs);

        window.customElements.whenDefined(EMBED_ELEMENT).then(() => {
            clearTimeout(timeout);
            resolve(true);
        });
    });
